var Backbone = require('backbone');
var _ = require('lodash');
var $ = require('jquery');

module.exports = Backbone.Model.extend({
  
    defaults: {
        authType: null,
        isAuthorized: false,
        userImage: null,
        userName: null,
        userID: null
    },
  
    initialize: function (attributes, options) {

        this.facebook = options.facebook;
        this.listenTo(this, 'change:userID', _.bind(this.defineUser, this));
        this.listenTo(this, 'change:authType', _.bind(this.isEmailUser, this));
        this.initializeType();
    },
    /**
     *
     */
    initializeType: function () {
    
    // // if FB SDK hasn't loaded, add listener
        if (this.facebook.get('status') === null) {
            this.facebook.once('change:status', _.bind(function () {
                this.initializeType();
            }, this));
        } else {
            switch (this.facebook.get('status')) {
            case 'connected':
                this.setUpFBUser();
                this.set({authType: 'facebook'});
                break;
            default:
                this.set({authType: 'email'});
                break;
            }
        }
    },
    /**
   *
   */
    setUpFBUser: function () {
        console.log('setUpFBUser', this.facebook.get('user'));
    
        if (!_.isNull(this.facebook.get('user'))) {
      
            var user = this.facebook.get('user');
      
            this.set({
                authType: 'facebook',
                fbData: user,
                userImage: user.avatar,
                userName: user.name,
                userID: user.email,
                isAuthorized: true
            });
      
        } else {
      
            // Add listener for when the Facebook user data is available
            this.facebook.once('change:user', _.bind(function () {
                console.log('waiting for user to initialize');
                this.setUpFBUser();
      
            }, this));
        }
    
    },
    /**
   *
   */
    defineUser: function (model, value, options) {
        console.log('defineUser', model, value, options);
    
        if ($.type(value) === 'null') {
            // if the user logs out, we no longer what their email address in localStorage
            if (!_.isUndefined(localStorage['vote_auth_email'])) {
                localStorage.removeItem('vote_auth_email');
            }
        } else {
            if (this.get('authType') === 'email' && _.isUndefined(localStorage['vote_auth_email'])) {
                localStorage['vote_auth_email'] = this.get('userID');
            }
        }
    },
    /**
   *
   */
    isEmailUser: function (model, value) {
        console.log('isEmailUser', model, value);
        if (value === 'email' && !_.isUndefined(localStorage['vote_auth_email']) && this.get('userID') === null) {
            console.log('Pulling userID from localStorage and setting it in the auth model', localStorage['vote_auth_email']);
            this.setUpEmailUser(localStorage['vote_auth_email']);
        }
    },
    /**
   *
   */
    deAuthorize: function () {
        console.log('calling deauthorize', this.get('authType'));
    
        switch (this.get('authType')) {
        case 'facebook':
            console.log('log out facebook');
            this.facebook.logout();
            break;
        case 'email':
            console.log('email');
            break;
        default:
            console.log('nothing');
            // do nothing
            break;
        }
    
        this.set(this.defaults);
    },
    /**
   *
   */
    signInSuccess: function(type, data){

        if(type === 'email'){
            if(!_.isNull(this.get('userID')) && this.get('userID') !== data){
                this.trigger('clearUser',{
                    target: this
                });
            }
            this.setUpEmailUser(data);
        } else if(type === 'facebook'){
            if($.type(this.facebook.get('user')) != 'null') {
                if(!_.isNull(this.get('userID')) && this.get('userID') !== this.facebook.get('user').email){
                    this.trigger('clearUser',{
                        target: this
                    });
                }
                this.setUpFBUser();
            } else {
                // Add listener for when the Facebook user data is available
                this.facebook.once('change:user', _.bind(function(){
                    console.log('waiting for user to initialize...');
                    this.signInSuccess('facebook');
                }, this));
            }
        }
    },
    /**
   *
   */
    setUpEmailUser: function (data) {
        console.log('setupEmailUser data:', data);
    
        this.set({
            authType: 'email',
            userName: data,
            userID: data,
            isAuthorized: true
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/models/auth.js
// module id = 208
// module chunks = 0